'use client';

import Image from 'next/image';
import Link from 'next/link';

import { PanelLeftClose, X } from 'lucide-react';
import useSWR from 'swr';

import { UserNav } from '@/components/app-sidebar/user-nav';
import { HomeAnchorLink } from '@/components/home-anchor-link';
import { menuItems } from '@/components/navigation-menu';
import { Button } from '@/components/ui/button';
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuAction,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarTrigger,
  useSidebar,
} from '@/components/ui/sidebar';
import { User } from '@/lib/db/schema';

const fetcher = (url: string) => fetch(url).then((res) => res.json());

export function PublicSidebar() {
  const { data: user } = useSWR<User>('/api/user', fetcher);
  const { state } = useSidebar();

  const CollapseIcon = () => (
    <>
      <X className="md:hidden" />
      <PanelLeftClose className="max-md:hidden" />
    </>
  );

  return (
    <Sidebar>
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem className="items-center">
            <SidebarMenuButton asChild className="hover:bg-inherit">
              <Link href="/">
                <SidebarTrigger className="w-0 overflow-hidden p-0 transition-all group-data-[state=collapsed]:w-5 group-data-[state=expanded]:!hidden [&>svg]:!size-5" />
                <Image
                  src="/statusly-logo.svg"
                  width={124}
                  height={43}
                  alt="Statusly logo"
                  className="transition-all group-data-[state=collapsed]:w-0"
                />
              </Link>
            </SidebarMenuButton>
            <SidebarMenuAction asChild>
              <SidebarTrigger IconCollapse={CollapseIcon} />
            </SidebarMenuAction>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupContent>
            <SidebarMenu>
              {menuItems.map((item) => (
                <SidebarMenuItem key={item.label}>
                  <SidebarMenuButton asChild>
                    <HomeAnchorLink href={item.href}>
                      <item.icon />
                      <span>{item.label}</span>
                    </HomeAnchorLink>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
      {user && (
        <SidebarFooter>
          <UserNav user={user!} />
        </SidebarFooter>
      )}
    </Sidebar>
  );
}
